//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'common_nav',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      activeTab: '0',
      activeType: '',
      activeShowType: ''
    };
  },
  methods: {
    tabChange: function tabChange(_, e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  computed: {
    goodsList: function goodsList() {
      var _ref = this.value.config.value[this.activeTab] || {},
        menus_type = _ref.menus_type,
        show_type = _ref.show_type;
      this.activeType = menus_type;
      this.activeShowType = show_type;
      return this.value.default_value[this.activeTab] || [];
    }
  }
};